export const environment = {
  production: false,
  borgoApiUrl: 'https://api-bo-test.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  // Note stage for Live BankID + SSO
  domain: 'borgo-loan-fe-stage.internal.sparbankensyd.se',
  developerMode: true,
  testMode: true
}
